import { getActiveBrandConfig, getActivePrestationBrandConfig } from "../../config/environment.config";

/**
 * Espace client repensé (2 novembre 2026) : adresses des rubriques du tableau
 * de bord commun, côté client. Mêmes URL que l'ancien espace, seule la vue
 * change (`RoleView` choisit la vue selon le rôle connecté).
 */
export const clientDashboardPath = (): string => `/${getActiveBrandConfig()}/tableau-de-bord`;
export const clientCoursesPath = (): string => `${clientDashboardPath()}/${getActivePrestationBrandConfig()}`;
export const clientDocumentsPath = (): string => `${clientDashboardPath()}/documents`;
export const clientSettingsPath = (): string => `${clientDashboardPath()}/parametre`;
export const clientHelpPath = (): string => `${clientDashboardPath()}/aide-contact`;
export const clientNotificationsPath = (): string => `${clientDashboardPath()}/notifications`;

/** Onglets de « Mes cours » côté client, portés par l'URL (`?onglet=`). */
export type ClientCoursesTab = "a-venir" | "passes";
export const CLIENT_COURSES_TAB_PARAM = "onglet";
export const isClientCoursesTab = (value: string | null | undefined): value is ClientCoursesTab => value === "a-venir" || value === "passes";
export const clientCoursesTabPath = (tab: ClientCoursesTab): string => `${clientCoursesPath()}?${CLIENT_COURSES_TAB_PARAM}=${tab}`;

/** Onglets des paramètres côté client. */
export type ClientSettingsTab = "profil" | "avance-immediate";
export const CLIENT_SETTINGS_TAB_PARAM = "onglet";
export const isClientSettingsTab = (value: string | null | undefined): value is ClientSettingsTab => value === "profil" || value === "avance-immediate";
export const clientSettingsTabPath = (tab: ClientSettingsTab): string => `${clientSettingsPath()}?${CLIENT_SETTINGS_TAB_PARAM}=${tab}`;
